
import { Grid } from '@mui/material'
import React, { Fragment, useState } from 'react'
import useFetchData from '../../../helpers/useFetch'
import AppURL from '../../../constants/AppURL'
import TapSizeCreateView from '../../../components/front_office/tap_size/TapSizeCreateView'
import TapSizeListView from '../../../components/front_office/tap_size/TapSizeListView'

const TapSizeCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.FrontOfficeURL + 'front/tap/size/create/list/view/');

    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };

  return (
    <Fragment>
    <Grid container spacing={3}>
        <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
            <TapSizeCreateView handleFormSuccess={handleFormSuccess} />
        </Grid>
        <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
            <TapSizeListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} data={data} error={error} loading={loading} />
        </Grid>
    </Grid>

</Fragment>
  )
}

export default TapSizeCreateListView